import {GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType} from "../../core/components/toolBar";
import {Config} from "../../core/config/config";
import {DialogHelper} from "../../core/util/dialogHelper";
import {General} from "../../../siteManagement/general";
import {SheetEventType} from "../../../siteManagement/sheet";
import {Helper} from "../../core/util/helper";
import {Grid} from "../../core/components/grid";
import {EditWorkPackageReportApp, EditWorkPackageReportProps} from "./editWorkPackageReport";
import {LinkedType, TemplateRequirementsEntity, WorkPackageEntity} from "./workPackage";
import React from "react";

export default class WorkPackageReportsGridApp extends React.Component<WorkPackageReportsGridProps,WorkPackageReportsGridState>{
    private _gridOptions = {};
    private _enabled: boolean;
    private capaReq = [];
    private searchSettings: { searchType?: string; displayPattern?: string; additionalParams?: string; mandatoryForNew?: boolean }
    private customButtonSettings: { machineAllocation?: boolean};
    taskMachinesDs: any[];

    constructor(props: WorkPackageReportsGridProps) {
        super(props); 
        this.searchSettings = props.field.searchSettings;
        this._enabled = !props.disabled;
        this.customButtonSettings = { ...this.customButtonSettings, ...props.field.customButtonSettings };
        this.loadCapaReq(props.entity.CapacityRequirements);
        this._gridOptions = this.props.context.workPackageReportsGridOptions;
        this.state = {
            MaschNrToFilter: props.entity.MaschNrToFilter,
            maschBezeichnung: this.getMaschbezeichnung(props.entity.MaschNrToFilter),
            gridData: []
        };
        this.taskMachinesDs = props.context.dataSources.taskMachines;
    }

    private getMaschbezeichnung = (maschNr: string) => {
        if (Helper.hasValue(maschNr)) {
            let index = this.props.context.dataSources.taskMachines.findIndex(f => f['Key'] === maschNr);
            return index > -1 ? this.props.context.dataSources.taskMachines[index]['Value'] : "";
        }
        return "";
    }

    componentDidUpdate(prevProps: WorkPackageReportsGridProps, prevState: WorkPackageReportsGridState) {
        if (this.props.entity.MaschNrToFilter !== this.state.MaschNrToFilter) {
            this.setState({
                MaschNrToFilter: this.props.entity.MaschNrToFilter,
                maschBezeichnung: this.getMaschbezeichnung(this.props.entity.MaschNrToFilter)
            }, this.loadGridData);
        }
    }

    private loadGridData = () => {
        let data = this.props.entity.TemplateRequirements
        for (let i = 0; i < data.length; i++) {
            data[i].CapacityRequirement = this.props.entity.CapacityRequirements.find(f => f.Id == data[i].CapacityRequirementId)
        }
        if (Helper.hasValue(this.state.MaschNrToFilter))
            data = data.filter(i => i.MaschNr === this.state.MaschNrToFilter);
        this.setState({gridData: data})
    }

    loadCapaReq = (ds) => {
        this.capaReq.length = 0;
        this.capaReq.push({Key:null, Value:''});
        for (let i = 0; i < ds.length; i++) {
            this.capaReq.push({ Key: ds[i].Id, Value: ds[i].Bezeichnung?.length > 0 ? ds[i].Bezeichnung : ds[i].Vorname + '  ' + ds[i].Name });
        }
    }  
    private _edit = (dataItem: any) => {
        this._openPos(dataItem);
    }
   
    private _openPos = async (dataItem: TemplateRequirementsEntity = null) => {
        let result = await Helper.getMetaData("editWorkpackageExtendedTemplate");
        this._initCodeWindow(dataItem, result);
    }

    create = () => {
        let searchType = "crtemplatereleased";
        let displayPattern = "[[Title]]";
        let additionalParams = "";
        let mandatory: boolean = null;
        if (Helper.hasValue(this.searchSettings)) {
            searchType = Helper.getValueOrDefault(this.searchSettings.searchType, searchType);
            displayPattern = Helper.getValueOrDefault(this.searchSettings.displayPattern, displayPattern);
            additionalParams = Helper.hasValue(this.searchSettings.additionalParams) ? "&" + this.searchSettings.additionalParams: additionalParams;
            mandatory = Helper.getValueOrDefault(this.searchSettings.mandatoryForNew, mandatory);
        }


        let url = `DynamicSearch/Window/${searchType}?fullObject=true&multi=true&displayPattern=${displayPattern}${additionalParams}`;
        
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, { disableTabTitle: true }); 
        sheet.bind(SheetEventType.ItemsSelected, (e: { data: Array<any> }) => {
            if (Array.isArray(e.data)) {
                let templateRequirementEntitys: TemplateRequirementsEntity[] = this.props.entity.TemplateRequirements;
                for (let i = 0; i < e.data.length; i++) {
                    let item: TemplateRequirementsEntity = {
                        Id: kendo.guid(),
                        IsNew: true,
                        IsWatchable: false,
                        IsWatched: false,
                        RecordRight: { CanRead: true, CanWrite: true },
                        TemplateId: e.data[i].Id,
                        Title: e.data[i].Title,
                        CapacityRequirementId: "",
                        CapacityRequirement: null,
                        Mandatory: mandatory,
                        MaschBezeichnung: Helper.getValueOrDefault(this.state.maschBezeichnung,""),
                        MaschNr: Helper.getValueOrDefault(this.state.MaschNrToFilter,""),
                        IndividualFields: null,
                        Remark: null,
                        LinkedTypeValue: Config.settings.globalLinkedType,
                        LinkedType: { Name: LinkedType[Config.settings.globalLinkedType], Title: Helper.getTranslation("Field.Enum.LinkedType." + LinkedType[Config.settings.globalLinkedType]), Value: Config.settings.globalLinkedType }
                    }
                    templateRequirementEntitys.push(item);
                }
                this.props.onChange({ model: "" }, templateRequirementEntitys);
                this.setState({  }, this.loadGridData);
            }
        });
    }

    private _initCodeWindow = (entity: TemplateRequirementsEntity, metaData: any) => {
        this.loadCapaReq(this.props.entity.CapacityRequirements);
        const entityCopy = JSON.parse(JSON.stringify(entity));
        const workPackageTemplateProps: EditWorkPackageReportProps = {
            disabled: this.props.disabled,
            entity: entityCopy,
            metadata: metaData,
            context: {
                key1: "entity.Id",
                keyVal1: entity.Id,
                contextType: "editWorkpackageExtendedTemplate",
                parentContextType: this.props.context.contextType
            },
            dataSources: {
                capacityReqDs: this.capaReq,
                taskMachinesDs: this.props.context.dataSources.taskMachines
            },
            isWindow: true,
            title: Helper.getTranslation("WebCRM.Tasks.WorkPackage.RequiredTemplates")
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully,
            (extendedTemplate: TemplateRequirementsEntity) => {
                let item = Helper.getArrayItem(this.props.entity.TemplateRequirements, "Id", extendedTemplate.Id);
                if (item == null) {
                    item = JSON.parse(JSON.stringify(extendedTemplate));
                    this.props.entity.TemplateRequirements.push(item);
                } else {
                    item.MaschNr = extendedTemplate.MaschNr;
                    item.MaschBezeichnung = extendedTemplate.MaschBezeichnung;
                    item.Title = extendedTemplate.Title;
                    item.TemplateId = extendedTemplate.TemplateId;
                    item.Mandatory = extendedTemplate.Mandatory;
                    item.Remark = extendedTemplate.Remark;
                    item.CapacityRequirementId = extendedTemplate.CapacityRequirementId;
                    item.LinkedType = extendedTemplate.LinkedType;
                    item.LinkedTypeValue = extendedTemplate.LinkedTypeValue;
                    item.IndividualFields = extendedTemplate.IndividualFields;
                    if (Helper.hasValue(item.CapacityRequirementId)) {
                        item.CapacityRequirement = this.props.entity.CapacityRequirements.find(f => f.Id == item.CapacityRequirementId);
                    }
                    else {
                        item.CapacityRequirement = null;
                    }
                    this.props.onChange(this.props.field, item.TemplateId);
                    this.loadGridData();
                }

            });

        sheet.show(() => {
            sheet.mountContent(EditWorkPackageReportApp, workPackageTemplateProps);
        });
    }
    private _deletePos = async (id: string) => {

        let isOk = await DialogHelper.confirm(Config.translations.delete);
        if (isOk) {
            let item = Helper.findObjIndex(this.props.entity.TemplateRequirements, "Id", id);
            if (item >= 0) {
                this.props.entity.TemplateRequirements.splice(item, 1);
                this.loadGridData();
                this.props.onChange(this.props.field, id);
            }
        }
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            let entity: TemplateRequirementsEntity = Helper.createEmptyEntity() as TemplateRequirementsEntity;
            entity.Id = kendo.guid();
            this.create();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this._edit(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._deletePos(dataItem.Id);
        }
    }

    handleCustomButtonClick = (id: string, dataItem: TemplateRequirementsEntity) => {
        if (id === "copy") {
            let entity: TemplateRequirementsEntity = JSON.parse(JSON.stringify(dataItem));
            entity.Id = kendo.guid();
            entity.IsNew = true;
            this.props.entity.TemplateRequirements.push(entity);
            this.loadGridData();
            this.props.onChange({ model: "entity.WorkPackages" }, this.props.entity.TemplateRequirements);
        }
        if (id === "auto_assignment") {
            let templatesWihtoutMachine = this.state.gridData.filter(x => Helper.isNullOrEmpty(x.MaschNr));
            for (let template of templatesWihtoutMachine) {
                let taskMachines = this.taskMachinesDs.filter(x => !Helper.isNullOrEmpty(x.Key));
                for (let machine of taskMachines) {
                    let entity: TemplateRequirementsEntity = JSON.parse(JSON.stringify(template));
                    if (Helper.isNullOrEmpty(template.MaschNr)) { //Vorhandene Bericht mit Maschine befüllen
                        template.MaschNr = machine.Key;
                        template.MaschBezeichnung = machine.Value;
                    }
                    else {
                        entity.Id = kendo.guid();
                        entity.IsNew = true;
                        entity.MaschNr = machine.Key;
                        entity.MaschBezeichnung = machine.Value;
                        this.props.entity.TemplateRequirements.push(entity);
                    }
                }
            }
            this.props.onChange({ model: "entity.WorkPackages" }, this.props.entity.TemplateRequirements);
        }
    }

    componentDidMount() {
        this.loadGridData()
    }

    private showCustomButton(setting?: boolean) {
        return !Helper.hasValue(setting) || setting;
    }

    render() {
        const customButtons: Array<GridCustomToolBarButton> = [];
        const enableButtons = this._enabled;
        const enableEditButton = this._enabled;
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: enableButtons });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: enableEditButton ? Config.translations.editLabel : Helper.getTranslation("WebCRM.Tasks.WorkPackage.Show"), enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: enableButtons });
        customButtons.push({ autoEnabledOnRecordSelected: true, caption: Config.translations.copyLabel, enabled: enableButtons, iconClass: "k-i-redo", id: "copy" });
        if (this.showCustomButton(this.customButtonSettings.machineAllocation))
            customButtons.push({ autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("WebCRM.Tasks.WorkPackage.MachineAllocation"), enabled: enableButtons, iconClass: "k-i-redo", id: "auto_assignment" });

        const content = <Grid data={this.state.gridData} options={this._gridOptions} id="workPackageReportsGrid"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} customButtons={customButtons} onClickCustomButton={this.handleCustomButtonClick} />

        return (content);
    }
}
interface WorkPackageReportsGridState {
    gridData: TemplateRequirementsEntity[];
    maschBezeichnung: string;
    MaschNrToFilter: string;
}

interface WorkPackageReportsGridProps{
    disabled: boolean;
    contextType: string;
    context: {
        contextType: string;
        workPackageReportsGridOptions: {},
        dataSources: {
            taskMachines: []
        }
        }
    translations: [];
    field: any;
    entity: WorkPackageEntity;
    onChange: (field, value) => void
}
